module.exports = __webpack_public_path__ + "static/media/sensa.9221f999.svg";